'use strict';
module.exports = {
    getContent: function () {
        //set from MVC as a global vairable
        return window.NOA.resourcedContent;
    } 
}


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./services/ContentService.js